import React, { memo } from 'react';
import { Image } from 'react-native';
import { rem } from 'design-system/values';
const source = require('design-system/img/emma-plan-ultimate.png');
const PlanEmmaUltimate = ({ size = rem(48) }) => (<Image source={source} style={{ width: size, height: size }}/>);
export default memo(PlanEmmaUltimate);
